module.exports = __webpack_public_path__ + "static/news9-2-4ece1b9dbe171c7e90aa560f4d065232.jpg";